import { EngagementDefinition } from '../base/EngagementDefinition';
import { StageTriviaEngagement } from './stage/stage-view';
import { FanTriviaEngagement } from './fan/fan-view';
import { TriviaEditorView } from './admin/editor-view';
import { TriviaAdminControlView } from './admin/control-view';
import {
  EngagementType,
  TriviaAdminConfig,
  TriviaAdminData,
  TriviaRoundStatus,
} from '@/generated/graphql';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { TRIVIA_DEFAULT_TIMER_MS } from './constants';

export const triviaEngagementDefinition: EngagementDefinition<
  TriviaAdminConfig,
  TriviaAdminData
> = {
  enabled: false,
  title: 'Trivia',
  Icon: QuestionMarkCircledIcon,
  type: EngagementType.Trivia,
  stageComponent: StageTriviaEngagement,
  fanComponent: FanTriviaEngagement,
  adminEditorView: TriviaEditorView,
  adminEditorOwnsLayout: true,
  adminControlView: TriviaAdminControlView,
  getInitialData: () => ({
    status: TriviaRoundStatus.Idle,
    questionIndex: 0,
    playedThroughIndex: -1,
    reviewing: false,
    questionEndsAt: null,
    answeredCount: 0,
    playerCount: 0,
    correctChoiceId: null,
    tallies: [],
    correctCount: 0,
    revealedQuestionIds: [],
    skipRevealedQuestionIds: [],
    skipped: false,
    leaderboard: [],
  }),
  getInitialConfig: () => ({
    instructions: '',
    useQuestionTimer: true,
    defaultTimerMs: TRIVIA_DEFAULT_TIMER_MS,
    questions: [],
  }),
};
